import { FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { getUserMedia } from '@public/workers/src/shared/utils/webApi/mediaDevices';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { useNotices } from '@/features/notices/useNotices';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { AccessErrorModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const AccessErrorModal: FC<AccessErrorModalProps> = ({ onSuccess }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'accessError' });
  const notice = useNotices();
  const modals = useModalsStore();

  const [loading, setLoading] = useState(false);

  const onAgain = async () => {
    setLoading(true);

    const mediaStream = await getUserMedia();

    if (!mediaStream) {
      notice.error(t('error'));
      setLoading(false);
      return;
    }

    mediaStream.getTracks().forEach((item) => item.stop());
    modals.closeModal();
    onSuccess?.();
    setLoading(false);
  };

  return (
    <ModalContainerV2 pinBottom title="">
      <Container>
        <Cross>
          <Icon name="x" size="s24" />
        </Cross>
        <TitleStyled>{t('title')}</TitleStyled>
        <Content>
          <b>{t('noAccess')}</b>
          <span>{t('allowText')}</span>
        </Content>
        <Buttons>
          <ButtonIw
            onClick={() => {
              modals.closeModal();
              modals.openModal({
                type: 'AccessTutorialModal',
              });
            }}
            type="default"
          >
            {t('howBtn')}
          </ButtonIw>
          <ButtonIw disabled={loading} loading={loading} onClick={onAgain}>
            {t('againBtn')}
          </ButtonIw>
        </Buttons>
      </Container>
    </ModalContainerV2>
  );
};

const Cross = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.systemFlame200};
  background: ${COLORS.systemFlame100};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 14px;
`;

const Buttons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;

  ${media.iwMobile} {
    flex-direction: column-reverse;
    margin-top: 16px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`;

const TitleStyled = styled(Title)`
  font-size: 22px !important;
`;
